import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { DataGrid } from '@mui/x-data-grid';
import Swal from 'sweetalert2';
import {Link, useParams} from 'react-router-dom';
import AutoComplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';

import { Chart, destroy } from 'chart.js/auto';
import SpeechRecognition, {useSpeechRecognition} from 'react-speech-recognition';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function IpConsDetail(props){

  const {cons_id}=useParams();
  const {ip_id} = useParams();
  const {appt_id} = useParams();
  const [inputValue, setInputValue] = useState('');
  const [appointment, setAppointment] = useState([]);
  const [ipData, setIpData] = useState([]);
  const [labview, setLabView] = useState([]);
  const [invview, setInvView] = useState([]);
  const [medview, setMedView] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [conData, setConData] = useState({});
  const [notesData, setNotesData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000));
  const [selectedDateTime, setSelectedDateTime] = useState(new Date());
  const [medicalDate, setMedicalDate] = useState(new Date());
  const [vitalData, setVitalData] = useState([]);
  const [icdData, setIcdData] = useState([]);
  const [codeData, setCodeData] = useState([]);
  const chartRef = useRef(null);

  const [registerFormData, setRegisterFormData] = useState({
        "weight":'',
        "height":'',
        "bmi":'',
        "allergy":'',
        "illness":'',
        "complaints":'',
        "diagnosis":'',
        "diet":'',
        "physio":'',
        "symptom":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
    });
  const [labitems, setlabItems] = useState([]);
  const [labrows, setlabrows] = useState([{ ID: '', Subcat: '', Amount: '' }]);
  const [labtotal, setlabTotal] = useState(0);
  const [labsubtotal, setlabsubtotal] = useState(0);
  const [labdisPer, setlabdisPer] = useState(0);
  const [labdisAmount, setlabdisAmount] = useState(0);
  const [labData,setLabData]=useState({
        "appt_id":'',
        "ip":'',
        "pat":'',
        "cons":'',
        "lab_id":'',
        "ltest_id":'',
        "lab_test":'',
        "lab_amount":'',
        "lab_tot":'',
        "lab_disc":'',
        "lab_status":'',
        "addedby":'',
        "ip_add":'',
    });
  const [invitems, setinvItems] = useState([]);
  const [invrows, setinvRows] = useState([{ ID: '', Subcat: '', Amount: '' }]);
  const [invtotal, setinvTotal] = useState(0);
  const [invsubtotal, setinvsubTotal] = useState(0);
  const [invdisPer, setinvdisPer] = useState(0);
  const [invdisAmount, setinvdisAmount] = useState(0);
  const [invData,setinvData]=useState({
        "appt_id":'',
        "ip":'',
        "pat":'',
        "cons":'',
        "inv_id":'',
        "itest_id":'',
        "inv_test":'',
        "inv_amount":'',
        "inv_tot":'',
        "inv_disc":'',
        "inv_status":'',
        "addedby":'',
        "ip_add":'',
    });

  const [minitems, setminItems] = useState([]);
  const [minrows, setminRows] = useState([{ ID: '', Subcat: '', Amount: '' }]);
  const [mintotal, setminTotal] = useState(0);
  const [minsubtotal, setminsubTotal] = useState(0);
  const [mindisPer, setmindisPer] = useState(0);
  const [mindisAmount, setmindisAmount] = useState(0);
  const [minData,setminData]=useState({
        "appt_id":'',
        "ip":'',
        "pat":'',
        "cons":'',
        "min_id":'',
        "min_test":'',
        "min_units":'',
        "min_amount":'',
        "min_tot":'',
        "min_disc":'',
        "min_status":'',
        "addedby":'',
        "ip_add":'',
    });
  const [medicalData,setMedicalData]=useState({
        "appt_id":'',
        "file_type":'',
        "files":'',
        "comments":'',
        "file_date":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
    });
  const [cnotesData, setcnotesData] = useState([]);
  const [consData, setConsData] = useState([]);
  const [conNoteData,setconNoteData]=useState({
        "ip":'',
        "cons":'',
        "notes":'',
        "notes_time":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
    });
const [language, setLanguage] = useState('');
    const [activeField, setActiveField] = useState(null); // which textarea is currently listening
const [transcripts, setTranscripts] = useState({
  allergy: '',
  illness: '',
  complaints: '',
  diagnosis: '',
  diet: '',
  physio: '',
  examination: ''
});
const { transcript, resetTranscript } = useSpeechRecognition({ continuous: true });

useEffect(() => {
  if (!activeField) return;

  setTranscripts(prev => ({
    ...prev,
    [activeField]: transcript
  }));
}, [transcript, activeField]);

const startListeningForField = (fieldName) => {
  setActiveField(fieldName);    // mark which field is active
  resetTranscript();            // clear previous transcript
  SpeechRecognition.startListening({ continuous: true, language });
};
const stopListening = () => {
  SpeechRecognition.stopListening();
  setActiveField(null);  // no active field
};


  const languages = [
  {
    no: "16",
    name: "English",
    native: "English",
    code: "en",
  },
  {
    no: "1",
    name: "Afrikaans",
    native: "Afrikaans",
    code: "af",
  },
  {
    no: "2",
    name: "Albanian",
    native: "Shqip",
    code: "sq",
  },
  {
    no: "3",
    name: "Arabic",
    native: "عربي",
    code: "ar",
  },
  {
    no: "4",
    name: "Armenian",
    native: "Հայերէն",
    code: "hy",
  },
  {
    no: "5",
    name: "Azerbaijani",
    native: "آذربایجان دیلی",
    code: "az",
  },
  {
    no: "6",
    name: "Basque",
    native: "Euskara",
    code: "eu",
  },
  {
    no: "7",
    name: "Belarusian",
    native: "Беларуская",
    code: "be",
  },
  {
    no: "8",
    name: "Bulgarian",
    native: "Български",
    code: "bg",
  },
  {
    no: "9",
    name: "Catalan",
    native: "Català",
    code: "ca",
  },
  {
    no: "10",
    name: "Chinese (Simplified)",
    native: "中文简体",
    code: "zh-CN",
  },
  {
    no: "11",
    name: "Chinese (Traditional)",
    native: "中文繁體",
    code: "zh-TW",
  },
  {
    no: "12",
    name: "Croatian",
    native: "Hrvatski",
    code: "hr",
  },
  {
    no: "13",
    name: "Czech",
    native: "Čeština",
    code: "cs",
  },
  {
    no: "14",
    name: "Danish",
    native: "Dansk",
    code: "da",
  },
  {
    no: "15",
    name: "Dutch",
    native: "Nederlands",
    code: "nl",
  },
  {
    no: "17",
    name: "Estonian",
    native: "Eesti keel",
    code: "et",
  },
  {
    no: "18",
    name: "Filipino",
    native: "Filipino",
    code: "tl",
  },
  {
    no: "19",
    name: "Finnish",
    native: "Suomi",
    code: "fi",
  },
  {
    no: "20",
    name: "French",
    native: "Français",
    code: "fr",
  },
  {
    no: "21",
    name: "Galician",
    native: "Galego",
    code: "gl",
  },
  {
    no: "22",
    name: "Georgian",
    native: "ქართული",
    code: "ka",
  },
  {
    no: "23",
    name: "German",
    native: "Deutsch",
    code: "de",
  },
  {
    no: "24",
    name: "Greek",
    native: "Ελληνικά",
    code: "el",
  },
  {
    no: "25",
    name: "Haitian Creole",
    native: "Kreyòl ayisyen",
    code: "ht",
  },
  {
    no: "26",
    name: "Hebrew",
    native: "עברית",
    code: "iw",
  },
  {
    no: "27",
    name: "Hindi",
    native: "हिन्दी",
    code: "hi",
  },
  {
    no: "28",
    name: "Hungarian",
    native: "Magyar",
    code: "hu",
  },
  {
    no: "29",
    name: "Icelandic",
    native: "Íslenska",
    code: "is",
  },
  {
    no: "30",
    name: "Indonesian",
    native: "Bahasa Indonesia",
    code: "id",
  },
  {
    no: "31",
    name: "Irish",
    native: "Gaeilge",
    code: "ga",
  },
  {
    no: "32",
    name: "Italian",
    native: "Italiano",
    code: "it",
  },
  {
    no: "33",
    name: "Japanese",
    native: "日本語",
    code: "ja",
  },
  {
    no: "34",
    name: "Korean",
    native: "한국어",
    code: "ko",
  },
  {
    no: "35",
    name: "Latvian",
    native: "Latviešu",
    code: "lv",
  },
  {
    no: "36",
    name: "Lithuanian",
    native: "Lietuvių kalba",
    code: "lt",
  },
  {
    no: "37",
    name: "Macedonian",
    native: "Македонски",
    code: "mk",
  },
  {
    no: "38",
    name: "Malay",
    native: "Malay",
    code: "ms",
  },
  {
    no: "39",
    name: "Maltese",
    native: "Malti",
    code: "mt",
  },
  {
    no: "40",
    name: "Norwegian",
    native: "Norsk",
    code: "no",
  },
  {
    no: "41",
    name: "Persian",
    native: "فارسی",
    code: "fa",
  },
  {
    no: "42",
    name: "Polish",
    native: "Polski",
    code: "pl",
  },
  {
    no: "43",
    name: "Portuguese",
    native: "Português",
    code: "pt",
  },
  {
    no: "44",
    name: "Romanian",
    native: "Română",
    code: "ro",
  },
  {
    no: "45",
    name: "Russian",
    native: "Русский",
    code: "ru",
  },
  {
    no: "46",
    name: "Serbian",
    native: "Српски",
    code: "sr",
  },
  {
    no: "47",
    name: "Slovak",
    native: "Slovenčina",
    code: "sk",
  },
  {
    no: "48",
    name: "Slovenian",
    native: "Slovensko",
    code: "sl",
  },
  {
    no: "49",
    name: "Spanish",
    native: "Español",
    code: "es",
  },
  {
    no: "50",
    name: "Swahili",
    native: "Kiswahili",
    code: "sw",
  },
  {
    no: "51",
    name: "Swedish",
    native: "Svenska",
    code: "sv",
  },
  {
    no: "52",
    name: "Thai",
    native: "ไทย",
    code: "th",
  },
  {
    no: "53",
    name: "Turkish",
    native: "Türkçe",
    code: "tr",
  },
  {
    no: "54",
    name: "Ukrainian",
    native: "Українська",
    code: "uk",
  },
  {
    no: "55",
    name: "Urdu",
    native: "اردو",
    code: "ur",
  },
  {
    no: "56",
    name: "Vietnamese",
    native: "Tiếng Việt",
    code: "vi",
  },
  {
    no: "57",
    name: "Welsh",
    native: "Cymraeg",
    code: "cy",
  },
  {
    no: "58",
    name: "Yiddish",
    native: "ייִדיש",
    code: "yi",
  },
];
     const handleDateTimeChange = (datetime) => {
        setSelectedDateTime(datetime);
    };

   useEffect(() => {
        fetchcnotesData();
   }, []);
    function fetchcnotesData() {
      axios.get(baseUrl + "view-consult-note/" + ip_id + "/")
        .then(response => {
          setcnotesData(response.data);
        })
        .catch(error => {
          console.log(error);
        });
    }

  const formconsSubmit = (e) => {
      e.preventDefault();
         const notes = document.getElementById("notes").value;
         const cons = document.getElementById("cons").value;
         const notes_time = document.getElementById("notes_time").value;
          const _formData = new FormData();
          _formData.append('ip', ip_id);
          _formData.append('cons', cons);
          _formData.append('notes', notes);
          _formData.append('notes_time', notes_time);
          _formData.append('status', '1');
          _formData.append('addedby', userName);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);

          axios.post(`${baseUrl}consult-note-create/`, _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'Notes Created Succesfully',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setconNoteData({
                  ip: '',
                  notes: '',
                  notes_time: '',
                  status: '',
                  addedby: '',
                  ip_add: '',
                });
                setTimeout(() => {
                  window.location.href = '/ip-cons-detail/'+ ip_id +'/';
                }, 3000);
              }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed. Please try again later.',
                'error'
              );
            });
  };
  const handleconsDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result)=>{
            if(result.isConfirmed){
               try{
                   axios.delete(baseUrl+'delete-consult-note/'+id+'/')
                   .then(function (response) {
                      Swal.fire('success', 'Data has been Deleted');
                    });
                    setTimeout(() => {
                    window.location.href = ('/ip-cons-detail/'+ip_id+'/');
                    }, 3000);
               }catch(error){
                    Swal.fire('error', 'Data has not been deleted');
               }
            }else{
                  Swal.fire('error', 'Data has not been deleted');
            }

        })
    }


   useEffect(() => {
        fetchnotesData();
   }, []);
    function fetchnotesData() {
      axios.get(baseUrl + "view-nurse-notes/" + ip_id + "/")
        .then(response => {
          setNotesData(response.data);
        })
        .catch(error => {
          console.log(error);
        });
    }

  const handleDateChange = (date) => {
  if (date) {
    const dateString = date.toISOString().slice(0,10);
    const dateObj = new Date(dateString);
    dateObj.setHours(0, 0, 0, 0);
    setSelectedDate(dateObj);
    }
    };
  const handleMedDateChange = (date) => {
  if (date) {
    const dateString = date.toISOString().slice(0,10);
    const dateObj = new Date(dateString);
    dateObj.setHours(0, 0, 0, 0);
    setMedicalDate(dateObj);
    }
    };

  useEffect(() => {
    fetchData();
    fetchconsData();
  }, []);

  function fetchData() {
    axios.get(baseUrl + "edit-ip-admit/" + ip_id + "/")
      .then(response => {
        setIpData([response.data]);
      })
      .catch(error => {
        console.log(error);
      });
  }
  function fetchconsData() {
      axios.get(baseUrl + "cons-search/")
      .then(response => {
        setConsData(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }

  useEffect(() => {
    fetchlviewData();
  }, []);

  function fetchlviewData() {
    axios.get(baseUrl + "view-ip-lab/" + ip_id)
      .then(response => {
        setLabView(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
    fetchiviewData();
  }, []);

  function fetchiviewData() {
    axios.get(baseUrl + "view-ip-inv/" + ip_id)
      .then(response => {
        setInvView(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }


  useEffect(() => {
    fetchConData();
  }, []);

  function fetchConData() {
    axios.get(baseUrl + "view-ip-consultform/" + ip_id)
      .then(response => {
        setConData(response.data);
        console.log(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
    fetchmedData();
  }, []);

  function fetchmedData() {
    axios.get(baseUrl + "view-files/" + ip_id)
      .then(response => {
        setMedView(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }

const inputHandler = (event) => {
      const { name, value } = event.target;

      if (conData.length > 0) {
        const updatedConData = [{ ...conData[0], [name]: value }];
        if (name === 'weight' || name === 'height') {
              const weight = parseFloat(updatedConData[0].weight);
              const height = parseFloat(updatedConData[0].height);

              if (!isNaN(weight) && !isNaN(height) && height > 0) {
                const bmi = (weight / ((height / 100) ** 2)).toFixed(2);
                updatedConData[0].bmi = bmi;
              }
            }
        setConData(updatedConData);
      } else {
        setConData([{ [name]: value }]);
      }
    };



  useEffect(() => {
    fetchLabData();
  }, []);

  function fetchLabData() {
    axios.get(`${baseUrl}lab-search/`)
      .then((labResponse) => {
        setlabItems(labResponse.data);

      })
      .catch(error => {
        console.log(error);
      });
  }


  useEffect(() => {
    fetchInvData();
  }, []);

  function fetchInvData() {
    axios.get(`${baseUrl}inv-search/`)
      .then((invResponse) => {
        setinvItems(invResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }

  useEffect(() => {
    fetchMinData();
  }, []);

  function fetchMinData() {
    axios.get(`${baseUrl}min-search/`)
      .then((minResponse) => {
        setminItems(minResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }

  const handleKeyDownlab = (e, index) => {
      const newlabrows = [...labrows];
      switch (e.keyCode) {
        // Handle Shift key
        case 16:
          e.preventDefault();
          if (index === labrows.length - 1) {
            newlabrows.push({ id:'', subcat: '', amount: '' });
          }
          break;
        // Handle arrow up key
        case 38:
          e.preventDefault();
          if (newlabrows[index].selectedItemlab === 0) {
            newlabrows[index].selectedItemlab = labitems.length - 1;
          } else {
            newlabrows[index].selectedItemlab--;
          }
          setlabrows(newlabrows);
          break;
        // Handle arrow down key
        case 40:
          e.preventDefault();
          if (newlabrows[index].selectedItemlab === labitems.length - 1) {
            newlabrows[index].selectedItemlab = 0;
          } else {
            newlabrows[index].selectedItemlab++;
          }
          setlabrows(newlabrows);
          break;
        default:
          break;
      }
      setlabrows(newlabrows);
    };

const handleSelectlab = (val, index) => {
  if (val === undefined || val === null) {
   const newlabrows = [...labrows];
      newlabrows[index] = { id: '', subcat: '', amount: '' };
      setlabrows(newlabrows);
    } else {
    const selectedItemlab = labitems.find(item => item.subcat === val);
    if (selectedItemlab) {
    const newlabrows = [...labrows];
    newlabrows[index] = {
      id: selectedItemlab.id,
      subcat: selectedItemlab.subcat,
      amount: selectedItemlab.amount
    };
    setlabrows(newlabrows);
    }
    }
  };

  const handleAmountChangelab = (e, index) => {
    const newlabrows = [...labrows];
    newlabrows[index].labamount = parseFloat(e.target.value) || 0;
    setlabrows(newlabrows);
  };

   const handleAddRowlab = () => {
    const newlabrows = [...labrows, { id:'', subcat: '', amount: '' }];
    setlabrows(newlabrows);
  };


  const inputlabRefs = useRef([]);

  useEffect(() => {
      inputlabRefs.current[inputlabRefs.current.length - 1]?.focus();
  }, [labrows]);

  const handleDeleteRowlab = (index) => {
    const newlabrows = [...labrows];
    newlabrows.splice(index, 1);
    setlabrows(newlabrows);
  };


  const handlelabdisPerChange = (e) => {
   const newlabdisPer = parseFloat(e.target.value) || 0;
   setlabdisPer(newlabdisPer);
  };


  useEffect(() => {
    let labsubtotal = 0;
    let labdisAmount = 0;

    let newlabTotal = 0;
    for (let i = 0; i < labrows.length; i++) {
      const row = labrows[i];
      labsubtotal += row.amount;
      labdisAmount = labsubtotal * ( parseFloat(labdisPer) /100 );
      newlabTotal = labsubtotal - labdisAmount;
    }
    setlabsubtotal(labsubtotal);
    setlabdisPer(labdisPer);
    setlabdisAmount(labdisAmount);
    setlabTotal(newlabTotal);
  }, [labrows, labdisPer]);

  const handlelabChange = (event) => {
    const { name, value } = event.target;
    setLabData(prevState => ({ ...prevState, [name]: value }));
  };

    const handleKeyDowninv = (e, index) => {
      const newinvRows = [...invrows];
      switch (e.keyCode) {
        // Handle Shift key
        case 16:
          e.preventDefault();
          if (index === invrows.length - 1) {
            newinvRows.push({ id:'', components: '', amount: '' });
          }
          break;
        // Handle arrow up key
        case 38:
          e.preventDefault();
          if (newinvRows[index].selectedIteminv === 0) {
            newinvRows[index].selectedIteminv = invitems.length - 1;
          } else {
            newinvRows[index].selectedIteminv--;
          }
          setinvRows(newinvRows);
          break;
        // Handle arrow down key
        case 40:
          e.preventDefault();
          if (newinvRows[index].selectedIteminv === invitems.length - 1) {
            newinvRows[index].selectedIteminv = 0;
          } else {
            newinvRows[index].selectedIteminv++;
          }
          setinvRows(newinvRows);
          break;
        default:
          break;
      }
      setinvRows(newinvRows);
    };

 const handleSelectinv = (val, index) => {
  if (val === undefined || val === null) {
  const newinvRows = [...invrows];
      newinvRows[index] = { id: '', components: '', amount: '' };
      setinvRows(newinvRows);
    } else {
    const selectedIteminv = invitems.find(item => item.components === val);
    if (selectedIteminv) {
    const newinvRows = [...invrows];
    newinvRows[index] = {
      id: selectedIteminv.id,
      components: selectedIteminv.components,
      amount: selectedIteminv.amount
    };
    setinvRows(newinvRows);
    }
    }
  };


  const handleAmountChangeinv = (e, index) => {
    const newinvRows = [...invrows];
    newinvRows[index].invamount = parseFloat(e.target.value) || 0;
    setinvRows(newinvRows);
  };

  const handleAddRowinv = () => {
        const newinvRows = [...invrows, { id: '', components: '', amount: '' }];
        setinvRows(newinvRows);
      };

  const inputinvRefs = useRef([]);

  useEffect(() => {
      inputinvRefs.current[inputinvRefs.current.length - 1]?.focus();
  }, [invrows]);

  const handleDeleteRowinv = (index) => {
    const newinvRows = [...invrows];
    newinvRows.splice(index, 1);
    setinvRows(newinvRows);
  };


  const handleinvDisPerChange = (e) => {
   const newinvdisPer = parseFloat(e.target.value) || 0;
   setinvdisPer(newinvdisPer);
  };


  useEffect(() => {
    let invsubTotal = 0;
    let invdisAmount = 0;

    let newinvTotal = 0;
    for (let i = 0; i < invrows.length; i++) {
      const row = invrows[i];
      invsubTotal += row.amount;
      invdisAmount = invsubTotal * ( parseFloat(invdisPer) /100 );
      newinvTotal = invsubTotal - invdisAmount;
    }
    setinvsubTotal(invsubTotal);
    setinvdisPer(invdisPer);
    setinvdisAmount(invdisAmount);
    setinvTotal(newinvTotal);
  }, [invrows, invdisPer]);


  const handleinvChange = (event) => {
    const { name, value } = event.target;
    setinvData(prevState => ({ ...prevState, [name]: value }));
  };
  const handleKeyDownmin = (e, index) => {
      const newminRows = [...minrows];
      switch (e.keyCode) {
        // Handle Shift key
        case 16:
          e.preventDefault();
          if (index === minrows.length - 1) {
            newminRows.push({ id:'', comp: '', amount: '' });
          }
          break;
        // Handle arrow up key
        case 38:
          e.preventDefault();
          if (newminRows[index].selectedItemmin === 0) {
            newminRows[index].selectedItemmin = minitems.length - 1;
          } else {
            newminRows[index].selectedItemmin--;
          }
          setminRows(newminRows);
          break;
        // Handle arrow down key
        case 40:
          e.preventDefault();
          if (newminRows[index].selectedItemmin === minitems.length - 1) {
            newminRows[index].selectedItemmin = 0;
          } else {
            newminRows[index].selectedItemmin++;
          }
          setminRows(newminRows);
          break;
        default:
          break;
      }
      setminRows(newminRows);
    };

   const handleSelectmin = (val, index) => {
     if (val === undefined || val === null) {
     const newminRows = [...minrows];
     newminRows[index] = { id: '', comp: '', amount: '' };
      setminRows(newminRows);
     } else {
    const selectedItemmin = minitems.find(item => item.comp === val);
    if (selectedItemmin) {
    const newminRows = [...minrows];
    newminRows[index] = {
      id: selectedItemmin.id,
      comp: selectedItemmin.comp,
      amount: selectedItemmin.amount
    };
    setminRows(newminRows);
    }
  }
  };

  const handleAmountChangemin = (e, index) => {
  const newminRows = [...minrows];
  newminRows[index].minunits = parseFloat(e.target.value) || 1;
  newminRows[index].minamount = parseFloat(newminRows[index].amount) || 0;
  const gt = newminRows[index].minunits * newminRows[index].minamount;
  newminRows[index].gt = gt;
  setminRows(newminRows);
  };

    const handleAddRowmin = () => {
        const newminRows = [...minrows, { id: '', comp: '', amount: '' }];
        setminRows(newminRows);
      };

  const inputminRefs = useRef([]);

  useEffect(() => {
      inputminRefs.current[inputminRefs.current.length - 1]?.focus();
  }, [minrows]);

  const handleDeleteRowmin = (index) => {
    const newminRows = [...minrows];
    newminRows.splice(index, 1);
    setminRows(newminRows);
  };


  const handleminDisPerChange = (e) => {
   const newmindisPer = parseFloat(e.target.value) || 0;
   setmindisPer(newmindisPer);
  };


  useEffect(() => {
    let minsubTotal = 0;
    let mindisAmount = 0;

    let newminTotal = 0;
    for (let i = 0; i < minrows.length; i++) {
      const row = minrows[i];
      minsubTotal += row.amount;
      mindisAmount = minsubTotal * ( parseFloat(mindisPer) /100 );
      newminTotal = minsubTotal - mindisAmount;
    }
    setminsubTotal(minsubTotal);
    setmindisPer(mindisPer);
    setmindisAmount(mindisAmount);
    setminTotal(newminTotal);
  }, [minrows, mindisPer]);


  const handleminChange = (event) => {
    const { name, value } = event.target;
    setminData(prevState => ({ ...prevState, [name]: value }));
  };
  const [ipStatus, setIpStatus] = useState(0);
  const handleCheckboxChange = (event) => {
    const value = event.target.checked ? 1 : 0;
    setIpStatus(value);
  };
  const handleMedChange = (event) => {
        setMedicalData({
            ...medicalData,
            [event.target.name]:event.target.value
        });
    }
  const handleFileChange = (event) => {
        setMedicalData({
            ...medicalData,
            [event.target.name]:event.target.files[0]
        });
    }

  const submitHandler = (e) => {
     e.preventDefault();
        const formData = new FormData();
        const symptoms = document.getElementById("symptoms").value;
        const icd = document.getElementById("icd").value;
        const id = conData.map(row => row.id);
        formData.append('ip', ip_id);
        formData.append('weight',conData[0].weight);
        formData.append('height',conData[0].height);
        formData.append('bmi',conData[0].bmi);
        formData.append('allergy',conData[0].allergy);
        formData.append('illness',conData[0].illness);
        formData.append('complaints',conData[0].complaints);
        formData.append('diagnosis',conData[0].diagnosis);
        formData.append('diet',conData[0].diet);
        formData.append('physio',conData[0].physio);
        formData.append('symptom',symptoms);
        if (icdData.icd) {
              formData.append('icd_disease', icdData.icd);
            }
        if (codeData.code) {
          formData.append('icd_code', codeData.code);
        }
        formData.append('ip_add', ipAddress);
          formData.append('location', userLocation);
        axios.put(baseUrl+'edit-ip-consult-form/'+id+'/', formData)
        .then((response) => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'Details Updated.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });

                setTimeout(() => {
                  window.location.href = '/ip-cons-detail/'+ ip_id +'/';
                }, 3000);
              }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to update',
                'error'
            );
          });

  };

  const formSubmitlab = (e) => {
      e.preventDefault();
          axios.post(`${baseUrl}get_appt_lab_number/`)
          .then(response => {
          const appt_lab = response.data.value;
          const _formData = new FormData();
          _formData.append('appt_id', appt_lab);
          _formData.append('ip', ip_id);
          _formData.append('pat', ipData.map(row => row.pat.id));
          _formData.append('cons', ipData.map(row => row.primary_consult.id));
          _formData.append('lab_id', appt_lab);
          _formData.append('ltest_id', labrows.map(row => row.id).join(','));
          _formData.append('lab_test', labrows.map(row => row.subcat).join(','));
          _formData.append('lab_amount', labrows.map(row => row.amount).join(','));
          _formData.append('lab_tot', labtotal);
          _formData.append('lab_disc', labdisAmount.toString());
          _formData.append('lab_status', '1');
          _formData.append('addedby', userName);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);

          axios.post(`${baseUrl}ip-lab-create/`, _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'Lab entry has been added.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setLabData({
                  appt_id: '',
                  pat: '',
                  cons: '',
                  lab_id: '',
                  ltest_id: '',
                  lab_test: '',
                  lab_amount: '',
                  lab_tot: '',
                  lab_disc: '',
                  lab_status: '',
                  addedby: '',
                  ip_add: '',
                });
                setlabrows([{ id: '', subcat: '', amount: '' }]);
                setlabTotal(0);
                setlabsubtotal(0);
                setlabdisPer(0);
                setlabdisAmount('');
                setTimeout(() => {
                  window.location.href = '/ip-cons-detail/'+ip_id +'/';
                }, 3000);
              }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to add lab entry. Please try again later.',
                'error'
              );
            });
        })
        .catch(error => {
          console.log(error);
          Swal.fire(
            'Error!',
            'Failed to generate unique value. Please try again later.',
            'error'
          );
        });
  };

    const formSubmitinv = (e) => {
      e.preventDefault();
          axios.post(`${baseUrl}get_appt_inv_number/`)
          .then(response => {
          const appt_inv = response.data.value;
          const _formData = new FormData();
          _formData.append('appt_id', appt_inv);
          _formData.append('ip', ip_id);
          _formData.append('pat', ipData.map(row => row.pat.id));
          _formData.append('cons', ipData.map(row => row.primary_consult.id));
          _formData.append('inv_id', appt_inv);
          _formData.append('itest_id', invrows.map(row => row.id).join(','));
          _formData.append('inv_test', invrows.map(row => row.components).join(','));
          _formData.append('inv_amount', invrows.map(row => row.amount).join(','));
          _formData.append('inv_tot', invtotal);
          _formData.append('inv_disc', invdisAmount.toString());
          _formData.append('inv_status', '1');
          _formData.append('addedby', userName);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);

          axios.post(`${baseUrl}ip-inv-create/`, _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'inv entry has been added.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setinvData({
                  appt_id: '',
                  pat: '',
                  cons: '',
                  inv_id: '',
                  ltest_id: '',
                  inv_test: '',
                  inv_amount: '',
                  inv_tot: '',
                  inv_disc: '',
                  inv_status: '',
                  addedby: '',
                  ip_add: '',
                });
                setinvRows([{ id: '', components: '', amount: '' }]);
                setinvTotal(0);
                setinvsubTotal(0);
                setinvdisPer(0);
                setinvdisAmount('');
                setTimeout(() => {
                  window.location.href = '/ip-cons-detail/'+ip_id+'/';
                }, 3000);
              }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to add inv entry. Please try again later.',
                'error'
              );
            });
        })
        .catch(error => {
          console.log(error);
          Swal.fire(
            'Error!',
            'Failed to generate unique value. Please try again later.',
            'error'
          );
        });
  };
  const formSubmitmin = (e) => {
      e.preventDefault();
          axios.post(`${baseUrl}get_appt_min_number/`)
          .then(response => {
          const appt_min = response.data.value;
          const _formData = new FormData();
          _formData.append('appt_id', appt_min);
          _formData.append('ip', ip_id);
          _formData.append('pat', ipData.map(row => row.pat.id));
          _formData.append('cons', ipData.map(row => row.primary_consult.id));
          _formData.append('min_id', minrows.map(row => row.id).join(','));
          _formData.append('min_test', minrows.map(row => row.comp).join(','));
          _formData.append('min_units', minrows.map(row => row.minunits).join(','));
          _formData.append('min_amount', minrows.map(row => row.amount).join(','));
          _formData.append('min_tot', mintotal);
          _formData.append('min_disc', mindisAmount.toString());
          _formData.append('min_status', '1');
          _formData.append('addedby', userName);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);

          axios.post(`${baseUrl}ip-min-create/`, _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'min entry has been added.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setminData({
                  appt_id: '',
                  pat: '',
                  cons: '',
                  min_id: '',
                  ltest_id: '',
                  min_test: '',
                  min_amount: '',
                  min_tot: '',
                  min_disc: '',
                  min_status: '',
                  addedby: '',
                  ip_add: '',
                });
                setminRows([{ id: '', comp: '', amount: '' }]);
                setminTotal(0);
                setminsubTotal(0);
                setmindisPer(0);
                setmindisAmount('');
                setTimeout(() => {
                  window.location.href = '/ip-cons-detail/'+ip_id+'/';
                }, 3000);
              }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to add min entry. Please try again later.',
                'error'
              );
            });
        })
        .catch(error => {
          console.log(error);
          Swal.fire(
            'Error!',
            'Failed to generate unique value. Please try again later.',
            'error'
          );
        });
  };
  const formSubmitmed = (e) => {
      e.preventDefault();
          const _formData = new FormData();
          const file_type = document.getElementById("ftype").value;
          _formData.append('appt_id', ip_id);
          _formData.append('file_type', file_type);
          if(medicalData.f_files!==''){
            _formData.append('files', medicalData.f_files, medicalData.f_files.name);
          }
          _formData.append('comments', medicalData.comments);
          _formData.append('file_date', medicalDate.toISOString().slice(0,10));
          _formData.append('status', '1');
          _formData.append('addedby', userName);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);

          axios.post(`${baseUrl}op-file-create/`, _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'File has been added.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setMedicalData({
                  appt_id: '',
                  file_type: '',
                  files: '',
                  comments: '',
                  file_date: '',
                  status: '',
                  addedby: '',
                  ip_add: '',
                });
                setTimeout(() => {
                  window.location.href = '/ip-cons-detail/'+ ip_id+'/';
                }, 3000);
              }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to add min entry. Please try again later.',
                'error'
              );
            });
  };
   const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result)=>{
            if(result.isConfirmed){
               try{
                   axios.delete(baseUrl+'delete-files/'+id)
                   .then(function (response) {
                      Swal.fire('success', 'Data has been Deleted');
                      window.location.reload();
                    });
               }catch(error){
                    Swal.fire('error', 'Data has not been deleted');
               }
            }else{
                  Swal.fire('error', 'Data has not been deleted');
            }

        })
    }
   const [insulinData, setinsulinData] = useState([]);
   useEffect(() => {
        fetchinsulinData();
   }, []);
    function fetchinsulinData() {
      axios.get(baseUrl + "view-insulin/" + ip_id + "/")
        .then(response => {
          setinsulinData(response.data);
        })
        .catch(error => {
          console.log(error);
        });
    }
    const [viewdietinData, setViewDietinData] = useState([]);
    const [viewdietoutData, setViewDietoutData] = useState([]);
    useEffect(() => {
        fetchdietinData();
        fetchdietoutData();
   }, []);
    function fetchdietinData() {
      axios.get(baseUrl + "view-diet-in/" + ip_id + "/")
        .then(response => {
          setViewDietinData(response.data);
        })
        .catch(error => {
          console.log(error);
        });
    }
    function fetchdietoutData() {
      axios.get(baseUrl + "view-diet-out/" + ip_id + "/")
        .then(response => {
          setViewDietoutData(response.data);
        })
        .catch(error => {
          console.log(error);
        });
    }
    const handleinDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result)=>{
            if(result.isConfirmed){
               try{
                   axios.delete(baseUrl+'delete-diet-in/'+id+'/')
                   .then(function (response) {
                      Swal.fire('success', 'Data has been Deleted');
                    });
                    setTimeout(() => {
                    window.location.href = ('/ip-cons-detail/'+ip_id+'/');
                    }, 3000);
               }catch(error){
                    Swal.fire('error', 'Data has not been deleted');
               }
            }else{
                  Swal.fire('error', 'Data has not been deleted');
            }

        })
    }
    const handleoutDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result)=>{
            if(result.isConfirmed){
               try{
                   axios.delete(baseUrl+'delete-diet-out/'+id+'/')
                   .then(function (response) {
                      Swal.fire('success', 'Data has been Deleted');
                    });
                    setTimeout(() => {
                    window.location.href = ('/ip-cons-detail/'+ip_id+'/');
                    }, 3000);
               }catch(error){
                    Swal.fire('error', 'Data has not been deleted');
               }
            }else{
                  Swal.fire('error', 'Data has not been deleted');
            }

        })
    }

    useEffect(() => {
    if (!chartRef.current) return;

    const ctx = chartRef.current.getContext("2d");

    // Clear the canvas
    ctx.clearRect(0, 0, chartRef.current.width, chartRef.current.height);
    const labels = vitalData.map(data => data.vital_time); // Assuming vital_time is the property in vitalData
    const datasets = [
      {
        label: "Temperature",
        data: vitalData.map(data => ({ x: Math.random(), y: data.tempr })), // Assuming tempr is the property in vitalData
        backgroundColor: "rgba(255, 99, 132, 0.5)",
        borderColor: "rgba(255, 99, 132, 1)",
        showLine: true,
      },
      {
        label: "Pulse",
        data: vitalData.map(data => ({ x: Math.random(), y: data.pulse })), // Assuming pulse is the property in vitalData
        backgroundColor: "rgba(54, 162, 235, 0.5)",
        borderColor: "rgba(54, 162, 235, 1)",
        showLine: true,
      },
      {
        label: "Respiration",
        data: vitalData.map(data => ({ x: Math.random(), y: data.resp })), // Assuming resp is the property in vitalData
        backgroundColor: "rgba(255, 206, 86, 0.5)",
        borderColor: "rgba(255, 206, 86, 1)",
        showLine: true,
      }
    ];

    const chart = new Chart(ctx, {
      type: "scatter", // Chart type set to "scatter"
      data: {
        labels: labels,
        datasets: datasets,
      },
      options: {
        responsive: true,
        scales: {
          x: {
            display: true,
            title: {
              display: true,
              text: "Time", // X-axis label
            },
          },
          y: {
            display: true,
            title: {
              display: true,
              text: "Value", // Y-axis label
            },
          },
        },
      },
    });

    // Cleanup function
    return () => {
      chart.destroy(); // Destroy chart instance on unmount
    };
  }, [vitalData]);

    useEffect(() => {
        fetchvitalData();
    }, []);
    function fetchvitalData() {
      axios.get(baseUrl + "view-vital/" + ip_id + "/")
        .then(response => {
          setVitalData(response.data);
        })
        .catch(error => {
          console.log(error);
        });
    }
    const [icdDisItems, seticdDisItems] = useState([]);

    useEffect(() => {
        fetchICDdisData('');
    }, []);

     function fetchICDdisData(keyword = '') {
      axios
        .get(`${baseUrl}icd-dis-search/?search=${keyword}`)
        .then((response) => {
          seticdDisItems(response.data.results);
        })
        .catch((error) => {
          console.error('Error fetching ICD disease data:', error);
        });
    }

    const icdDisCodeOptions = icdDisItems.map((icd) => ({
      value: icd.disease_code,
      label: icd.disease_desc,
    }));
    const handleConsChange = (event, value) => {
      if (value) {
        setIcdData(prevState => ({ ...prevState, icd: value.value }));
      } else {
        setIcdData(prevState => ({ ...prevState, icd: '' }));
      }
    };

    const [icdcodeItems, seticdCodeItems] = useState([]);

    useEffect(() => {
        fetchICDcodeData('');
    }, []);

     function fetchICDcodeData(keyword = '') {
      axios
        .get(`${baseUrl}icd-code-search/?search=${keyword}`)
        .then((response) => {
          seticdCodeItems(response.data.results);
        })
        .catch((error) => {
          console.error('Error fetching ICD disease data:', error);
        });
    }

    const icdCodeOptions = icdcodeItems.map((code) => ({
      value: code.sub_category,
      label: code.title,
    }));

    const handleCodeChange = (event, value) => {
      if (value) {
        setCodeData(prevState => ({ ...prevState, code: value.value }));
      } else {
        setCodeData(prevState => ({ ...prevState, code: '' }));
      }
    };

    return (
    <section className="container mt-4">
     <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-stethoscope" aria-hidden="true" style={{ color: 'red' }}></i>
      Primary Consultant -  Dr.{ipData.map(row => row.primary_consult.consultant)}

        <Link to={`/ip-pat-print/${ip_id}`} className="btn btn-success ms-1">
          IP Admit Card
        </Link>
    </h3>
    <div className="table-responsive">
    <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Patient</th>
          <th>IP ID</th>
          <th>Patient ID</th>
          <th>Patient Name</th>
          <th>Gender</th>
          <th>D.O.B/Age</th>
          <th>Mobile</th>
          <th>Regd. On</th>
        </tr>
      </thead>
      <tbody>
        {ipData.map((patientData, index) => (
          <tr >
          <td><img src={patientData.profile_pic} alt="Thumbnail" className="thumbnail" style={{width:120, height:60}}/></td>
            <td>{patientData.ip_id}</td>
            <td>{patientData.pat.pat_id}</td>
            <td>{patientData.pat.patient}</td>
            <td>{patientData.pat.gender}</td>
            <td>{patientData.pat.age}</td>
            <td>{patientData.pat.mobile}</td>
            <td>{formatDateTime(patientData.admit_date)}</td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
    <nav>
      <div className="nav nav-tabs" id="nav-tab" role="tablist">
      <button className="nav-link active border-success" id="nav-case-sheet-tab" data-bs-toggle="tab"
            data-bs-target="#nav-case-sheet" type="button" role="tab" aria-controls="nav-case-sheet"
            aria-selected="true">Case Sheet</button>
        <button className="nav-link  border-primary " id="nav-nurse-tab" data-bs-toggle="tab"
            data-bs-target="#nav-nurse" type="button" role="tab" aria-controls="nav-nurse"
            aria-selected="false">Nurse Notes</button>
        <button className="nav-link  border-primary " id="nav-cons-tab" data-bs-toggle="tab"
            data-bs-target="#nav-cons" type="button" role="tab" aria-controls="nav-cons"
            aria-selected="false">Consultant Notes</button>
        <button className="nav-link  border-primary " id="nav-insulin-tab" data-bs-toggle="tab"
            data-bs-target="#nav-insulin" type="button" role="tab" aria-controls="nav-insulin"
            aria-selected="false">Insulin Scale</button>
        <button className="nav-link  border-primary " id="nav-diet-tab" data-bs-toggle="tab"
            data-bs-target="#nav-diet" type="button" role="tab" aria-controls="nav-diet"
            aria-selected="false">Diet Chart Summary</button>
        <button className="nav-link  border-primary " id="nav-lab-tab" data-bs-toggle="tab"
            data-bs-target="#nav-lab" type="button" role="tab" aria-controls="nav-lab"
            aria-selected="false">Lab</button>
        <button className="nav-link  border-primary " id="nav-inv-tab" data-bs-toggle="tab"
            data-bs-target="#nav-inv" type="button" role="tab" aria-controls="nav-inv"
            aria-selected="false">Radiology</button>
        <button className="nav-link  border-primary " id="nav-min-tab" data-bs-toggle="tab"
            data-bs-target="#nav-min" type="button" role="tab" aria-controls="nav-min"
            aria-selected="false">Min. Treat</button>
        <button className="nav-link  border-primary " id="nav-med-tab" data-bs-toggle="tab"
            data-bs-target="#nav-med" type="button" role="tab" aria-controls="nav-med"
            aria-selected="false">Medical Summary</button>
        <button className="nav-link  border-primary " id="nav-vitals-tab" data-bs-toggle="tab"
            data-bs-target="#nav-vitals" type="button" role="tab" aria-controls="nav-vitals"
            aria-selected="false">Vitals</button>
      </div>
    </nav>

<div className="tab-content" id="nav-tabContent">
  <div className="tab-pane" id="nav-nurse" role="tabpanel" aria-labelledby="nav-nurse-tab">
    <div className="card card-body">
      <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <i className="fa-solid fa-user-nurse" aria-hidden="true" style={{ color: 'red' }}></i>
          Nurse Notes History
          <i className="fa-brands fa-discourse"></i>
        </h3>
        <div className="table-responsive">
      <table className="erp-table-modern">
      <thead>
            <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
              <th>Date</th>
              <th>Notes</th>
              <th>Delete</th>
            </tr>
      </thead>
      <tbody>
        {notesData.map((dis, index) => (
              <tr >
                <td>{formatDateTime(dis.notes_time)}</td>
                <td>{dis.notes}</td>
                <td>
                  <button className="btn btn-danger" type="button" onClick={() => handleDelete(dis.id)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
        </table>
        </div>
      </div>
  </div>
  <div className="tab-pane" id="nav-cons" role="tabpanel" aria-labelledby="nav-cons-tab">
      <div >
  <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-user-doctor" aria-hidden="true" style={{ color: 'red' }}></i>
      Consultant Notes
    </h3>
      <form>
      <div className="row">
        <div className="col-md-3">
        <label htmlFor="Notes" className="form-label">Consultant : </label>
            <select name="cons" id="cons" className="form-control">
                {consData.map((consultant,index) => {return <option key={index} value={consultant.id}>{consultant.consultant}
                </option>})}
            </select>
            </div>
        <div className="col-md-6">
          <label htmlFor="Notes" className="form-label">Notes : </label>
        <textarea className="no-comma" tabIndex={0} name="notes" id="notes"
                value={transcripts.illness || (conData.length > 0 && conData[0].illness !== undefined ? conData[0].illness : registerFormData.illness)}
                onChange={inputHandler} />
                <button
                      className="btn btn-danger ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        SpeechRecognition.stopListening();
                      }}
                    >
                      <i className="fa fa-microphone-lines-slash"></i>
                    </button>
                    <button
                      className="btn btn-success ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        startListeningForField('illness'); // <-- important: pass field name
                      }}
                    >
                      <i className="fa fa-microphone-lines"></i>
                    </button>
        </div>
        <div className="col-md-3">
          <label htmlFor="Notes Time" className="form-label">Notes Time : </label>
          <DatePicker className="form-control" name="notes_time" id="notes_time" selected={selectedDateTime}
                onChange={handleDateTimeChange}
                dateFormat="yyyy-MM-dd h:mm"
                showTimeSelect
                timeIntervals={15}
                timeCaption="Time"
            />
        </div>
       </div>
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='ms-5 mb-5' >
          <button type="button" onClick={formconsSubmit} className="btn btn-primary mt-4">Submit</button>
        </div>
      </form>
      <div className="card card-body">
      <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <i className="fa-solid fa-user-doctor" aria-hidden="true" style={{ color: 'red' }}></i>
          Consultant Notes History
          <i className="fa-brands fa-discourse"></i>
        </h3>
        <div className="table-responsive">
      <table className="erp-table-modern">
      <thead>
            <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
              <th>Date</th>
              <th>Consultant</th>
              <th>Notes</th>
              <th>Delete</th>
            </tr>
      </thead>
      <tbody>
        {cnotesData.map((dis, index) => (
              <tr >
                <td>{formatDateTime(dis.notes_time)}</td>
                <td>{dis.cons.consultant}</td>
                <td>{dis.notes}</td>
                <td>
                  <button className="btn btn-danger" type="button" onClick={() => handleconsDelete(dis.id)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
        </table>
        </div>
      </div>
    </div>
  </div>
  <div className="tab-pane" id="nav-insulin" role="tabpanel" aria-labelledby="nav-insulin-tab">
    <div className="card card-body">
      <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <i className="fa-solid fa-syringe" aria-hidden="true" style={{ color: 'red' }}></i>
          Insulin History
        </h3>
        <div className="table-responsive">
      <table className="erp-table-modern">
      <thead>
            <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
              <th>Date</th>
              <th colSpan="6">Insulin Details</th>
              <th>Delete</th>
            </tr>
      </thead>
      <tbody>
        {insulinData.map((dis, index) => (
              <tr >
                <td>{formatDateTime(dis.insulin_time)}</td>
                <td>Fluid : {dis.fluid}</td>
                <td>Drug - Units: {dis.drug} - {dis.units}</td>
                <td>Drops: {dis.drops}</td>
                <td>INS : {dis.ins}</td>
                <td>Blood Sugar : {dis.bls}</td>
                <td>Sugar Type : {dis.blstype}</td>
                <td>
                  <button className="btn btn-danger" type="button" onClick={() => handleDelete(dis.id)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
        </table>
        </div>
      </div>
  </div>
  <div className="tab-pane" id="nav-diet" role="tabpanel" aria-labelledby="nav-diet-tab">
     <div className="card card-body mt-5">
      <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <i className="fa-solid fa-apple-whole" aria-hidden="true" style={{ color: 'red' }}></i>
          Diet Intake History
        </h3>
        <div className="table-responsive">
      <table className="erp-table-modern">
      <thead>
            <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
              <th>Date</th>
              <th colSpan="7">Intake Details</th>
              <th>Notes</th>
              <th>Delete</th>
            </tr>
      </thead>
      <tbody>
        {viewdietinData.map((din, index) => (
              <tr >
                <td>{formatDateTime(din.in_time)}</td>
                <td>{din.blood}</td>
                <td>{din.bqty}</td>
                <td>{din.fluid}</td>
                <td>{din.fqty}</td>
                <td>{din.ngqty}</td>
                <td>{din.oral}</td>
                <td>{din.oqty}</td>
                <td>{din.in_notes}</td>
                <td>
                  <button className="btn btn-danger" type="button" onClick={() => handleinDelete(din.id)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
        </table>
      </div>
      </div>
      <div className="card card-body mt-5">
      <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <i className="fa-solid fa-poo" aria-hidden="true" style={{ color: 'red' }}></i>
          Diet Out History
        </h3>
        <div className="table-responsive">
      <table className="erp-table-modern">
      <thead>
            <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
              <th>Date</th>
              <th colSpan="5">Output Details</th>
              <th>Notes</th>
              <th>Delete</th>
            </tr>
      </thead>
      <tbody>
        {viewdietoutData.map((dout, index) => (
              <tr >
                <td>{formatDateTime(dout.out_time)}</td>
                <td>{dout.urine}</td>
                <td>{dout.uqty}</td>
                <td>{dout.motion}</td>
                <td>{dout.mqty}</td>
                <td>{dout.ngqty}</td>
                <td>{dout.out_notes}</td>
                <td>
                  <button className="btn btn-danger" type="button" onClick={() => handleoutDelete(dout.id)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
        </table>
        </div>
      </div>
  </div>
  <div className="tab-pane" id="nav-vitals" role="tabpanel" aria-labelledby="nav-vitals-tab">
    <canvas ref={chartRef}></canvas>
  </div>
  <div className="tab-pane" id="nav-lab" role="tabpanel" aria-labelledby="nav-lab-tab">
     <form>
      <div className="table-responsive">
      <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th style={{width: 50}}>ID</th>
          <th style={{width: 270}}>Lab Test Name</th>
          <th style={{width: 70}}>Total</th>
          <th style={{width: 70}}>Action</th>
        </tr>
      </thead>

    <tbody>
    {labrows.map((row, index) => (
    <tr key={index} >
        <td>
        <input
            type="text"

            name="ltest_id"
            value={row.id}
            onChange={(e) => handlelabChange(e, index, 'id')}
            readOnly
            style={{ width: 70 }}
          />
          </td>
          <td>
            <AutoComplete

                value={row.subcat}
              options={labitems.map(item => item.subcat)}
              onChange={(event, val) => handleSelectlab(val, index)}

              onInputChange={(event, newlabInputValue) => {
                // Update input value
                setlabrows(prevlabRows => {
                  const updatedlabRows = [...prevlabRows];
                  updatedlabRows[index].subcat = newlabInputValue;
                  return updatedlabRows;
                });
              }}
             onKeyDown={e => handleKeyDownlab(e, index)}
             renderInput={(params) => (
              <div ref={params.InputProps.ref}
              >
                <input className="form-control" type="text" {...params.inputProps} focused autoFocus
                       fullWidth
                       style={{
                          width: 300,
                          background: "#F7EEFF",
                          }}
                 />
              </div>
            )}
             ref={(el) => inputlabRefs.current[index] = el}
            />
          </td>
          <td>
          <input
            type="number"

            value={row.amount}
            name="labamount"
            onChange={handlelabChange}
            onChange={(e) => handleAmountChangelab(e, index)}
            readOnly
            style={{ width: 150 }}
          />
          </td>
          <td>
          <button className="btn btn-danger" type="button" onClick={() => handleDeleteRowlab(index)}>Delete</button>
          </td>
        </tr>
      ))}
       </tbody>

        </table>
      <button className="btn btn-success addmore mt-4" type="button" onClick={handleAddRowlab}>Add More</button>
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='ms-5' >
            <div className="form-group" style={{display:'none'}}>
                <label style={{ fontWeight: 'bold' }}>labsubtotal: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">&#8377;</div>
                       <input type="number" value={labsubtotal} readOnly/>
                </div>
            </div>
            <div className="form-group mt-3" style={{display:'none'}}>
                <label style={{ fontWeight: 'bold' }}>Discount: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">%</div>
                       <input type="number" value={labdisPer} name="labdisPer" id="labdisPer"
                           onChange={handlelabdisPerChange} />
                </div>
            </div>
            <div className="form-group mt-3" style={{display:'none'}}>
                <label style={{ fontWeight: 'bold' }}>Discount Amount: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">&#8377;</div>
                      <input type="number" onChange={handlelabChange} name="labdisAmount" id="labdisAmount" value={labdisAmount} />
                </div>
            </div>
            <div className="form-group mt-3" style={{display:'none'}}>
                <label style={{ fontWeight: 'bold' }}>Total: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">&#8377;</div>
                        <input type="number" onChange={handlelabChange} name="labtot" value={labtotal} readOnly/>
                </div>
            </div>
          <button type="button" onClick={formSubmitlab} className="btn btn-primary mt-4">Submit</button>
        </div>
        </div>
       </form>

       <div className="row mt-4">
       <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
        <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
       Lab Request View</h3>
       <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Appt ID</th>
          <th>Test Name</th>
          <th>Addedby</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {labview.map((labviewData, index) => (
          <tr >
            <td>{labviewData.appt_id}</td>
            <td>{labviewData.lab_test}</td>
            <td>{labviewData.addedby}</td>
            <td>
              {labviewData.lab_status == '1' ? (
                <span className="badge bg-warning">pending in cashier</span>
              ) : labviewData.lab_status == '2' ? (
                <span className="badge bg-success">Sent to Lab</span>
              ) : labviewData.lab_status == '3' ? (
                <span className="badge bg-success">View</span>
              ) : (
                <span>unknown status</span>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
  </div>
  <div className="tab-pane" id="nav-inv" role="tabpanel" aria-labelledby="nav-inv-tab">
              <form>
      <div className="table-responsive">
          <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th style={{width: 50}}>ID</th>
          <th style={{width: 270}}>Inv Test Name</th>
          <th style={{width: 70}}>Total</th>
          <th style={{width: 70}}>Action</th>
        </tr>
      </thead>

      <tbody>

      {invrows.map((row, index) => (
        <tr key={index} >
        <td>
        <input
            type="text"
            name="itest_id"
            value={row.id}
            onChange={(e) => handleinvChange(e, index, 'id')}
            readOnly
            style={{width: 120}}
          />
            </td>
              <td>
                <AutoComplete
                  value={row.components}
                  options={invitems.map(item => item.components)}
                  onChange={(event, val) => handleSelectinv(val, index)}
                  onInputChange={(event, newinvInputValue) => {
                    // Update input value
                    setinvRows(previnvRows => {
                      const updatedinvRows = [...previnvRows];
                      updatedinvRows[index].components = newinvInputValue;
                      return updatedinvRows;
                    });
                  }}
                 onKeyDown={e => handleKeyDowninv(e, index)}
                 renderInput={(params) => (
                  <div ref={params.InputProps.ref}
                  >
                    <input className="form-control" type="text" {...params.inputProps} focused autoFocus
                           fullWidth
                           style={{
                              width: 270,
                              background: "#F7EEFF",
                              }}
                     />
                  </div>
                )}
                 ref={(el) => inputinvRefs.current[index] = el}
                />
              </td>
              <td>
              <input
                type="number"

                value={row.amount}
                name="invamount"
                onChange={handleinvChange}
                onChange={(e) => handleAmountChangeinv(e, index)}
                readOnly
                style={{width: 150}}
              />
              </td>
              <td>
              <button className="btn btn-danger" type="button" onClick={() => handleDeleteRowinv(index)}>Delete</button>
            </td>
        </tr>
      ))}
      </tbody>
      </table>
      <button className="btn btn-success addmore mt-4" type="button" onClick={handleAddRowinv}>Add More</button>
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='ms-5' >
            <div className="form-group"  style={{display:'none'}}>
                <label style={{ fontWeight: 'bold' }}>Subtotal: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">&#8377;</div>
                       <input type="number" value={invsubtotal} readOnly/>
                </div>
            </div>
            <div className="form-group mt-3" style={{display:'none'}} >
                <label style={{ fontWeight: 'bold' }}>Discount: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">%</div>
                       <input type="number" value={invdisPer} name="invdisPer" id="invdisPer"
                           onChange={handleinvDisPerChange} />
                </div>
            </div>
            <div className="form-group mt-3" style={{display:'none'}} >
                <label style={{ fontWeight: 'bold' }}>Discount Amount: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">&#8377;</div>
                      <input type="number" onChange={handleinvChange} name="invdisAmount" id="invdisAmount" value={invdisAmount} />
                </div>
            </div>
            <div className="form-group mt-3" style={{display:'none'}}>
                <label style={{ fontWeight: 'bold' }}>Total: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">&#8377;</div>
                        <input type="number" onChange={handleinvChange} name="invtot" value={invtotal} readOnly/>
                </div>
            </div>
          <button type="button" onClick={formSubmitinv} className="btn btn-primary mt-4">Submit</button>
        </div>

        </div>
       </form>

       <div className="row mt-4">
       <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
        <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
       Radiology Request View
       </h3>
       <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Appt ID</th>
          <th>Test Name</th>
          <th>Addedby</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {invview.map((invviewData, index) => (
          <tr >
            <td>{invviewData.appt_id}</td>
            <td>{invviewData.inv_test}</td>
            <td>{invviewData.addedby}</td>
            <td>
              {invviewData.inv_status == '1' ? (
                <span className="badge bg-warning">pending in cashier</span>
              ) : invviewData.inv_status == '2' ? (
                <span className="badge bg-success">Sent to Radiology</span>
              ) : invviewData.inv_status == '3' ? (
                <span className="badge bg-success">View</span>
              ) : (
                <span>unknown status</span>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
  </div>
  <div className="tab-pane" id="nav-min" role="tabpanel" aria-labelledby="nav-min-tab">
           <form>
      <div className="table-responsive">
          <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th style={{width: 80}}>ID</th>
          <th style={{width: 150}}>Min. Test Name</th>
          <th style={{width: 150}}>Units</th>
          <th style={{width: 150}}>Total</th>
          <th style={{width: 150}}>G.Total</th>
          <th style={{width: 80}}>Action</th>
        </tr>
      </thead>

      <tbody>

      {minrows.map((row, index) => (
        <tr key={index}>
        <td>
        <input
            type="text"
            name="ltest_id"
            value={row.id}
            onChange={handleminChange}
            style={{width: 120}}
            readOnly
          />

           </td>
              <td>
                <AutoComplete
                   value={row.comp}
                   options={minitems.map(item => item.comp)}

                  onChange={(event, val) => handleSelectmin(val, index)}
                  onInputChange={(event, newminInputValue) => {
                    // Update input value
                    setminRows(prevminRows => {
                      const updatedminRows = [...prevminRows];
                      updatedminRows[index].comp = newminInputValue;
                      return updatedminRows;
                    });
                  }}
                 onKeyDown={e => handleKeyDownmin(e, index)}
                 renderInput={(params) => (
                  <div ref={params.InputProps.ref}
                  >
                    <input className="form-control" type="text" {...params.inputProps} focused autoFocus
                           fullWidth
                           style={{
                              width: 270,
                              background: "#F7EEFF",
                              }}
                     />
                  </div>
                )}
                 ref={(el) => inputminRefs.current[index] = el}
                />
              </td>
              <td>
          <input
            type="number"
            className="ms-5 me-5"
            value={row.minunits}
            name="minunits"
            onChange={(e) => {
                handleminChange(e);
                handleAmountChangemin(e, index);
              }}
            required
          />
          </td>
          <td>
          <input
            type="number"
            className="ms-2 me-5"
            value={row.amount}
            name="minamount"
            onChange={handleminChange}
            onChange={(e) => handleAmountChangemin(e, index)}
            readOnly
          />
           </td>
          <td>
          <input
            type="number"
            className="ms-2 me-5"
            value={row.gt}
            name="gt"
            readOnly
          />
           </td>
          <td>
          <button className="btn btn-danger" type="button" onClick={() => handleDeleteRowmin(index)}>Delete</button>
        </td>
        </tr>
      ))}
         </tbody>
      </table>
      <button className="btn btn-success addmore mt-4" type="button" onClick={handleAddRowmin}>Add More</button>
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='ms-5' >
            <div className="form-group"  style={{display:'none'}}>
                <label style={{ fontWeight: 'bold' }}>Subtotal: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">&#8377;</div>
                       <input type="number" value={minsubtotal} readOnly/>
                </div>
            </div>
            <div className="form-group mt-3" style={{display:'none'}} >
                <label style={{ fontWeight: 'bold' }}>Discount: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">%</div>
                       <input type="number" value={mindisPer} name="mindisPer" id="mindisPer"
                           onChange={handleminDisPerChange} />
                </div>
            </div>
            <div className="form-group mt-3" style={{display:'none'}} >
                <label style={{ fontWeight: 'bold' }}>Discount Amount: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">&#8377;</div>
                      <input type="number" onChange={handleminChange} name="mindisAmount" id="mindisAmount" value={mindisAmount} />
                </div>
            </div>
            <div className="form-group mt-3" style={{display:'none'}}>
                <label style={{ fontWeight: 'bold' }}>Total: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">&#8377;</div>
                        <input type="number" onChange={handleminChange} name="mintot" value={mintotal} readOnly/>
                </div>
            </div>
          <button type="button" onClick={formSubmitmin} className="btn btn-primary mt-4">Submit</button>
        </div>
        </div>
       </form>
  </div>
  <div className="tab-pane" id="nav-med" role="tabpanel" aria-labelledby="nav-med-tab">
           <div className="row mt-4">
       <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
        <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
        Medical File Upload
       </h3>
       <form>
       <div className="table-responsive">
       <table className="erp-table-modern">
        <tbody>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
            <td>Type of File : </td>
            <td>
            <select name="ftype" id="ftype" value={medicalData.ftype} onChange={handleMedChange}>
            <option value="ctscan">CT-Scan</option>
            <option value="xray">X-Ray</option>
            <option value="casesheet">Case Sheet</option>
            <option value="other">Other Docs</option>
            </select>
            </td>
          </tr>
          <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
            <td>File Created Date : </td>
            <td>
             <DatePicker selected={medicalDate} onChange={handleMedDateChange} dateFormat="yyyy-MM-dd" name="date"  value={medicalData.date}/>
            </td>
          </tr>
          <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
            <td>Comments : </td>
            <td>
             <textarea className="no-comma" tabIndex="0" name="comments" id="comments"
                value={medicalData.comments}
                onChange={handleMedChange} >
             </textarea>
            </td>
          </tr>
          <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
            <td>File Upload :</td>
            <td>
          <input type="file" className="form-control" name="f_files"
            onChange={handleFileChange} id="f_files" />

          </td>
          </tr>
      </tbody>
    </table>
    </div>
    <button type="button" onClick={formSubmitmed} className="btn btn-primary mt-4">Submit</button>
    </form>
    </div>
      <div className="row mt-4">
       <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
        <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
       Medical Document View
       </h3>
       <div className="table-responsive">
       <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Appt ID</th>
          <th>File Type</th>
          <th>File Date</th>
          <th>Comments</th>
          <th>View</th>
          <th>Addedby</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {medview.map((medviewData, index) => (
          <tr >
            <td>{medviewData.appt.appt_id}</td>
            <td>{medviewData.file_type}</td>
            <td>{medviewData.file_date}</td>
            <td>{medviewData.comments}</td>
            <td>
            <div >
              <iframe src={medviewData.files} title={medviewData.files}
              allowfullscreen></iframe>
            </div>
            </td>
            <td>{medviewData.addedby}</td>
            <td>
            <button onClick={()=> handleDelete(medviewData.id)} className="btn btn-danger btn-sm ms-1">
            <i className="fa-solid fa-trash-can"></i></button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
    </div>
  </div>
     <div className="tab-pane fade show active" id="nav-case-sheet" role="tabpanel" aria-labelledby="nav-case-sheet-tab">
        <form>
            <div className="row mt-4">
            <div className="col-md-2 mb-3">
                <label htmlFor="Weight" className="form-label">Weight (Kg)</label>

                <input type="number" maxLength={10} placeholder="Weight" className="form-control"
                name="weight"
                value={conData.length > 0 && conData[0].weight !== undefined ? conData[0].weight : registerFormData.weight}
                onChange={inputHandler} />
            </div>
            <div className="col-md-2 mb-3">
                <label htmlFor="Height" className="form-label">Height (cm)</label>
                <input type="number" maxLength={10} placeholder="Height" className="form-control"
                name="height"
                value={conData.length > 0 && conData[0].height !== undefined ? conData[0].height : registerFormData.height}
                onChange={inputHandler} />
            </div>
            <div className="col-md-2 mb-3">
                <label htmlFor="BMI" className="form-label">BMI</label>
                <input type="number" maxLength={10} placeholder="BMI" className="form-control"
                    name="bmi"
                    value={conData.length > 0 && conData[0].bmi !== undefined ? conData[0].bmi : registerFormData.bmi}
                    onChange={inputHandler} readOnly/>
            </div>
            <div className="col-md-2 mb-3">
             <label htmlFor="Symptoms" className="form-label">Symptoms</label>
              <select className="form-control"
              value={conData.length > 0 && conData[0].symptom !== undefined ? conData[0].symptom : registerFormData.symptom}
              onChange={inputHandler}
                name="symptom" id="symptoms" >
                <option value="Headache">Headache</option>
                <option value="Fever">Fever</option>
                <option value="Running Nose">Running Nose</option>
                <option value="Sore Throat">Sore Throat</option>
                <option value="Sneezing">Sneezing</option>
                <option value="Cough">Cough</option>
                <option value="Sputum">Sputum</option>
                <option value="Wheeze">Wheeze</option>
                <option value="Dyspnea">Dyspnea</option>
                <option value="PND">PND</option>
                <option value="Pedal Oedema">Pedal Oedema</option>
                <option value="Anasarca">Anasarca</option>
                <option value="Puffy Face">Puffy Face</option>
                <option value="Swelling">Swelling</option>
                <option value="Neck Swelling">Neck Swelling</option>
                <option value="Groin ">Groin </option>
                <option value="Pain">Pain</option>
                <option value="Itching">Itching</option>
                <option value="Urticaria">Urticaria</option>
                <option value="Weakness">Weakness</option>
                <option value="Vertigo">Vertigo</option>
                <option value="Unsteadiness">Unsteadiness</option>
                <option value="Chest Pain">Chest Pain</option>
                <option value="Burning Micturition">Burning Micturition</option>
                <option value="Frequency Of Urine">Frequency Of Urine</option>
                <option value="Urgency">Urgency</option>
                <option value="Diarrhea">Diarrhea</option>
                <option value="Constipation">Constipation</option>
                <option value="Bleeding PR">Bleeding PR</option>
                <option value="Epigastric Pain">Epigastric Pain</option>
                <option value="Loin Pain ">Loin Pain </option>
                <option value="Loin Pain Radiating to Rt Groin">Loin Pain Radiating to Rt Groin</option>
                <option value="Loin Pain Radiating to Lt Groin">Loin Pain Radiating to Lt Groin</option>
                <option value="LBA">LBA</option>
                <option value="LBA Radiating to Right Thigh">LBA Radiating to Rt Thigh</option>
                <option value="LBA Radiating to Left Thigh">LBA Radiating to Lt Thigh</option>
                <option value="Neck Pain">Neck Pain</option>
                <option value="Neck Pain Radiating to Right Upper Limb">Neck Pain Radiating to Rt Upper Limb</option>
                <option value="Neck Pain Radiating to Left Upper Limb">Neck Pain Radiating to Left Upper Limb</option>
              </select>
            </div>
            </div>
            <div className="row">
            <div className="col-md-2 mb-3">
            <label htmlFor="Allergies" className="form-label">Allergies</label>
                <textarea className="no-comma" tabIndex="0" name="allergy" id="allergy"
                 value={conData.length > 0 && conData[0].allergy !== undefined ? conData[0].allergy : registerFormData.allergy}
                 onChange={inputHandler} >
                </textarea>
            </div>
            <div className="col-md-2 mb-3">
            <label htmlFor="Other Illness" className="form-label">Other Illness</label>
                <textarea className="no-comma" tabIndex="0" name="illness" id="illness"

                onChange={inputHandler} >
                </textarea>
            </div>
            <div className="col-md-2 mb-3">
            <label htmlFor="Complaints" className="form-label">Complaints</label>
                <textarea className="no-comma" tabIndex="0" name="complaints" id="complaints"
                 value={conData.length > 0 && conData[0].complaints !== undefined ? conData[0].complaints : registerFormData.complaints}
                 onChange={inputHandler} >
                </textarea>
            </div>
            <div className="col-md-2 mb-3">
            <label htmlFor="Diagnosis" className="form-label">Diagnosis</label>
                <textarea className="no-comma" tabIndex="0" name="diagnosis" id="diagnosis"
                value={conData.length > 0 && conData[0].diagnosis !== undefined ? conData[0].diagnosis : registerFormData.diagnosis}
                onChange={inputHandler} >
                </textarea>
            </div>
            <div className="col-md-2 mb-3">
            <label htmlFor="Dietician Notes" className="form-label">Dietician Notes</label>
                <textarea className="no-comma" tabIndex="0" name="diet" id="diet"
                value={conData.length > 0 && conData[0].diet !== undefined ? conData[0].diet : registerFormData.diet}
                onChange={inputHandler} >
                </textarea>
            </div>
            <div className="col-md-2 mb-3">
            <label htmlFor="Physio Notes" className="form-label">Physio Notes</label>
                <textarea className="no-comma" tabIndex="0" name="physio" id="physio"
                value={conData.length > 0 && conData[0].physio !== undefined ? conData[0].physio : registerFormData.physio}
                onChange={inputHandler} >
                </textarea>
            </div>
            </div>
            <div className="row">
            <div className="col-md-12 text-center mb-5">
            <label htmlFor="ICD Disease" className="form-label">ICD Disease Code</label>
                <AutoComplete
                  id="icd"
                  name="icd"
                  options={icdDisCodeOptions}
                  getOptionLabel={(option) => option.label}
                  getOptionSelected={(option, value) => option.value === value}
                  onChange={(event, value) => {
                    setIcdData((prevState) => ({
                      ...prevState,
                      icd: value ? value.value : '', // Set the selected disease_code or an empty string if no value is selected
                    }));
                  }}
                  renderInput={(params) => <TextField {...params} onChange={handleConsChange} name="icd" id="icd" />}
                />
            </div>
            <div className="col-md-12 text-center mb-5">
            <label htmlFor="ICD Procedure" className="form-label">ICD Procedure Code</label>
                <AutoComplete
                  id="code"
                  name="code"
                  options={icdCodeOptions}
                  getOptionLabel={(option) => option.label}
                  getOptionSelected={(option, value) => option.value === value}
                  onChange={(event, value) => {
                    setCodeData((prevState) => ({
                      ...prevState,
                      code: value ? value.value : '', // Set the selected disease_code or an empty string if no value is selected
                    }));
                  }}
                  renderInput={(params) => <TextField {...params} onChange={handleCodeChange} name="code" id="code" />}
                />
            </div>
    </div>
            <div className="row">
            <div className="col-md-12 text-center mb-5">
            <button type="button" onClick={submitHandler}
            className="btn btn-success">Submit</button>
            </div>
            </div>
            </form>
        </div>
      </div>

    </section>
    )
}

export default IpConsDetail;